/**
 * Validate if product is ready for trip selection step
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct(to);
    const { firstStepRoute } = useFlow(to);

    if (!product.value.dateFrom) {
        return navigateTo(firstStepRoute.value);
    }
});
